module.exports = __webpack_public_path__ + "img/img_lianghua_waihui@3x.a7ec9184.png";